<div class="b-a">

    <!-- title -->
    <div (click)="pick()"
         class="p-t p-b p-l-8 p-r-8"
         [attr.for]="name">
        <radio><input type="radio"
                   [name]="name"
                   [disabled]="disabled"
                   [ngModel]="model"
                   (ngModelChange)="onChange($event)"
                   [value]="value">
            <p class="s1"><ng-content select="[title]"></ng-content></p>
        </radio>
        <p class="p1 m-t-2 _hideEmpty"><ng-content select="[subtitle]"></ng-content></p>
    </div>

    <!-- body -->
    <hide-up [open]="toggleState"
             class="m-l-8 m-r-8">
        <ng-content select="[body]"></ng-content>
    </hide-up>
</div>